if (!global._babelPolyfill) {
    require('babel-polyfill');
}

import Vue from 'vue';
import RazzSearchTool from './RazzSearchTool.vue';


if ( !window.vueComponents ) {
    window.vueComponents = {};
}

window.vueComponents['RazzSearchTool'] = RazzSearchTool;

window.run_search_tool = function() {

    Vue.nextTick(() => {

        let rfpg_container = document.getElementById("razz-search-tool");

        if ( document.body.contains(rfpg_container) ) {
            Vue.component('razz-search-tool', window.vueComponents.RazzSearchTool);

            new Vue({
                el: '#razz-search-tool',
            });
        }
    });
};